<template>
	<div class="p_box" id="box">
		<div id="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/Homet' }" replace>首页</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/Sent' }" replace>已发作业</el-breadcrumb-item>
				<el-breadcrumb-item>查看详情</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="p_m_t_30 public_box overflow" :style="{ height: height + 'px' }">
			<div class=" public_padding">
				<div class="p_flex">
					<span class="type_size_22 ">{{name}}</span>
				</div>
				<div class="p_flex p_f_a   p_m_t_20 type_size_18">
					<div class="p_flex center p_f_1">
						<span class="subject_color">{{classLevel}}</span>
						<el-divider direction="vertical"></el-divider>
						<span class="subject_yellow">{{subject_def}}</span>
						<el-divider direction="vertical"></el-divider>
						<span >{{age}}道题</span>
						<el-divider direction="vertical"></el-divider>
						<span >{{score}}分</span>
						<div class="divss">{{already_submit}}人提交</div>
					</div>
				</div>
				<div class="p_flex p_f_a   p_m_t_20 type_size_18">
					<div class="p_flex center p_f_1">
						<span>提交时间 {{create_date}} 至 {{submit_date}}</span>
					</div>
				</div>
				<div class="p_m_t_30 type_size_22 subject_color">全部题目</div>
			</div>
			<div class="">
				<deatil-list :id="id" @names="names"></deatil-list>
			</div>
		</div>
	</div>
</template>

<script>
	import DeatilList from './commponents/deatilList.vue'
export default {
	name: 'PerformDeatil',
	components:{
		DeatilList
	},
	data() {
		return {
			height: 0,
			id:"",
			name:"", // 名字
			classLevel:"", //班级
			create_date:"", //从什么时间
			submit_date:"" ,// 到什么时间
			subject_def:"" ,// 科目
			score:"" , //总分
			age:"", //总共几道题
			already_submit:"" ,  //已提交人数
		};
	},
	created(){
		this.id=this.$route.query.id
	},
	mounted() {
		this.indexInfo();
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/PerformDeatil') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},
	methods: {
		names(val,age){
			// console.log(val,age)
			this.age=age
			this.classLevel=val.classLevel.name
			this.name=val.name
			this.subject_def=val.subject_def
			this.score=val.score
			this.already_submit=val.already_submit
			this.submit_date=val.submit_date
			this.create_date=val.create_date
		},
		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			var height = box - head - 30;
			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		}
	},
	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	}
};
</script>

<style lang="scss" scoped>
.divss{
	margin:0 0 0 30px;
}
.public_box {
	background-color: #ffffff;
}

.public_padding {
	padding: 30px 260px 0;
}

>>> .el-tag--dark.el-tag--success {
	background-color: #00af63;
	border-color: #00af63;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/sent/deatil.vue